var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ops-section" },
    [
      _c(
        "el-card",
        { staticClass: "ops-page", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "ops-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [_vm._v("商城设置")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "opsForm",
              staticClass: "ops-form",
              attrs: { model: _vm.form },
            },
            [
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("推荐区")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "recommendation-area" }, [
                    _c(
                      "div",
                      { staticClass: "recommendation-items" },
                      [
                        _vm._l(
                          _vm.form.recommendations,
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "recommendation-item",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "image-upload-container" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "custom-uploader" },
                                      [
                                        item.images && item.images.length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "image-preview" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "preview-item",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "preview-image",
                                                      attrs: {
                                                        src: item.images[0].url,
                                                        alt: item.images[0]
                                                          .name,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "preview-actions",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-zoom-in preview-btn",
                                                          attrs: {
                                                            title: "预览",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handlePictureCardPreview(
                                                                item.images[0]
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-delete preview-btn ",
                                                          attrs: {
                                                            title: "删除",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleRemove(
                                                                null,
                                                                [],
                                                                index
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "upload-area",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.triggerFileInput(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  ref: "fileInput" + index,
                                                  refInFor: true,
                                                  staticStyle: {
                                                    display: "none",
                                                  },
                                                  attrs: {
                                                    type: "file",
                                                    accept: "image/*",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleFileChange(
                                                        $event,
                                                        index
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass: "el-icon-plus",
                                                }),
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "upload-tip1" },
                                          [_vm._v("只能上传jpg/png文件")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "path-input" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入跳转地址",
                                        size: "mini",
                                      },
                                      model: {
                                        value: item.path,
                                        callback: function ($$v) {
                                          _vm.$set(item, "path", $$v)
                                        },
                                        expression: "item.path",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("el-button", {
                                  staticClass: "delete-btn",
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-close",
                                    disabled:
                                      _vm.form.recommendations.length <= 1,
                                    title: "删除此推荐项",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeRecommendation(index)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "add-recommendation",
                            on: { click: _vm.addRecommendation },
                          },
                          [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "add-text" }, [
                              _vm._v("添加推荐"),
                            ]),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "config-links" }, [
                    _c("div", { staticClass: "link-item" }, [
                      _vm._v("礼券: /pages/shop/coupon/index"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "link-item" }, [
                      _vm._v("礼品卡: /pages/shop/cards/index"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "link-item" }, [
                      _vm._v(
                        "卡详情: /pages/shop/cards/detail/index?id={id} ({id}:查阅礼品卡列表)"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "link-item" }, [
                      _vm._v("卡券商城: GAGAX:/pages/plus/index"),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("祝福语")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticClass: "blessings-textarea",
                        attrs: {
                          type: "textarea",
                          rows: 6,
                          placeholder:
                            "愿所有美好如期而至&#10;往后余生,不负流年,平安喜乐!&#10;愿你多些幸运&#10;愿有人成为你的盖世英雄&#10;元气满满,荷包满满,开心满满!",
                        },
                        model: {
                          value: _vm.form.blessings,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "blessings", $$v)
                          },
                          expression: "form.blessings",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "blessings-tip" }, [
                        _vm._v("每个祝语回车键分割"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ops-actions" },
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, size: "tiny" },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }